export const cacheQueryKeys = {
  PublicOrgData: 'publicOrgData',
  OnlineBookingTimeSlots: 'onlineBookingTimeSlots',
  AvailablePublicServices: 'availablePublicServices',
  ConfirmPaymentData: 'confirmPaymentData',
  OnlineBookingInvoices: 'onlineBookingInvoices',
  PaymentStatus: 'paymentStatus',
};

export default cacheQueryKeys;
